<template>
  <div>
    <div class="footer-style">
      <div class="hidden-sm-and-down">
        <el-row :gutter="20">
          <!-- <el-col :md="6" style="text-align: left; padding: 0% 10%">  -->
          <el-col :md="6">
            <img src="@/assets/new/login_blanco.svg" class="logo-footer" alt="Login Farma" />
          </el-col>
          <el-col :md="6" :xs="24" class="integridad-css"
            ><h3 class="title_footer">{{ $t('footer.titulo_1') }}</h3>
            <hr class="linea-blanca" />
            <p class="p-css" style="margin-top: 25px; margin-bottom: 10%" v-html="$t('footer.direccion')"></p>
            <!-- <p class="p-css"></p> -->
            <!-- <link rel="stylesheet" href="" /> -->
            <router-link
              class="css-link"
              style="font-family: 'roboto-cursiva-bold'; margin: 0px"
              to="/programa-integridad"
              :class="{ menuActivo: menuActivo === 'integridad' }"
              v-scroll-to="{ el: '#', offset: 0 }">
              {{ $t('footer.integridad') }}
            </router-link>
            <!-- <a href="/programa-integridad" style="margin: 0px" class="css-link">{{ $t('footer.integridad') }}</a> -->
          </el-col>
          <el-col :md="6" :xs="24" class="redes-css" style="text-align: justify"
            ><h3 class="title_footer">
              {{ $t('footer.titulo_2') }}
              <hr class="linea-blanca" />
            </h3>
            <div style="margin-top: 25px">
              <p class="p-css">
                <a href="https://www.instagram.com/loginfarma/" target="_blank" style="color: white; text-decoration: none">
                  <img src="@/assets/iconos/10_Redes Sociales - ICONO.png" class="icono-footer" alt="icono-footer" />
                  LOGINFARMA
                </a>
              </p>
              <p class="p-css">
                <a href="https://www.linkedin.com/company/loginfarma/" target="_blank" style="color: white; text-decoration: none">
                  <img src="@/assets/iconos/11_Redes Sociales - ICONO.png" class="icono-footer" alt="icono-footer" />
                  LOG-IN FARMA
                </a>
              </p>
            </div>
          </el-col>
          <el-col :md="6" :xs="24" class="asesoramiento-css" style="text-align: left"
            ><h3 class="title_footer">
              {{ $t('footer.titulo_3') }}
              <hr class="linea-blanca" />
            </h3>
            <div style="margin-top: 25px">
              <p class="p-css">{{ $t('footer.telefono') }}</p>
              <p class="p-css">
                <a style="text-decoration: none !important; color: white !important" href="mailto:info@tudominio.com">{{ $t('footer.email') }}</a>
              </p>

              <p class="p-css">
                <router-link class="css-link_2" :to="{ name: 'home', hash: '#comercial' }"> {{ $t('footer.asesoramiento') }}</router-link>
              </p>
              <p class="p-css">
                <router-link class="css-link_2" to="/trabaja-nosotros" v-scroll-to="{ el: '#trabaja', offset: 0 }"> {{ $t('footer.trabajo') }}</router-link>
              </p>
            </div>
          </el-col></el-row
        >
      </div>
      <div class="hidden-md-and-up">
        <el-row class="padding-footer1"
          ><el-col class="integridad-css">
            <h3 class="title_footer">{{ $t('footer.titulo_1') }}</h3>
            <hr class="linea-blanca" />
            <p class="p-css" style="margin-bottom: 5%" v-html="$t('footer.direccion')"></p>
            <!-- <p class="p-css"></p> -->
            <!-- <link rel="stylesheet" href="" /> -->
            <router-link
              class="css-link"
              style="font-family: 'roboto-cursiva-bold'; margin: 0px"
              to="/programa-integridad"
              :class="{ menuActivo: menuActivo === 'integridad' }"
              v-scroll-to="{ el: '#', offset: 0 }">
              {{ $t('footer.integridad') }}
            </router-link>
            <!-- <a href="/programa-integridad" style="margin: 0px" class="css-link">{{ $t('footer.integridad') }}</a> -->
          </el-col>
        </el-row>
        <el-row class="padding-footer">
          <el-col class="redes-css" style="text-align: justify"
            ><h3 class="title_footer">
              {{ $t('footer.titulo_2') }}
              <hr class="linea-blanca" />
            </h3>
            <p class="p-css">
              <a href="https://www.instagram.com/loginfarma/" target="_blank" style="color: white; text-decoration: none">
                <img src="@/assets/iconos/10_Redes Sociales - ICONO.png" class="icono-footer" alt="icono-footer" />
                LOGINFARMA
              </a>
            </p>
            <p class="p-css">
              <a href="https://www.linkedin.com/company/loginfarma/" target="_blank" style="color: white; text-decoration: none">
                <img src="@/assets/iconos/11_Redes Sociales - ICONO.png" class="icono-footer" alt="icono-footer" />
                LOG-IN FARMA
              </a>
            </p>
          </el-col>
        </el-row>
        <el-row class="padding-footer2">
          <el-col :md="6" :xs="24" class="asesoramiento-css" style="text-align: left"
            ><h3 class="title_footer">
              {{ $t('footer.titulo_3') }}
              <hr class="linea-blanca" />
            </h3>
            <p class="p-css">{{ $t('footer.telefono') }}</p>
            <p class="p-css">
              <a style="text-decoration: none !important; color: white !important" href="mailto:info@tudominio.com">{{ $t('footer.email') }}</a>
            </p>

            <p class="p-css">
              <router-link class="css-link_2" :to="{ name: 'home', hash: '#comercial' }"> {{ $t('footer.asesoramiento') }}</router-link>
            </p>
            <p class="p-css">
              <router-link class="css-link_2" to="/trabaja-nosotros" v-scroll-to="{ el: '#trabaja', offset: 0 }"> {{ $t('footer.trabajo') }}</router-link>
            </p>
          </el-col></el-row
        >
        <el-row style=""
          ><el-col><img src="@/assets/new/login_blanco.svg" class="logo-footer" alt="Login Farma" /></el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>
<style lang="scss">
.icono-footer {
  width: 6.2%;
  vertical-align: middle;
  // font-weight: 900;
  margin-bottom: 5px;
}
.p-css {
  font-family: 'roboto-regular';
  font-size: 17px;
  // margin: 10px;
  color: white;
  text-decoration: none;
  margin: 0px 0px 5px 0px;
  line-height: 1.5;
}
.css-link {
  color: white;
  // font-size: 17px;
  font-style: normal;
  font-family: 'roboto-regular';
  margin: 10px;
  // font-weight: 900;
}
.css-link_2 {
  color: white;
  font-family: 'roboto-regular';
}
.linea-blanca {
  grid-column: 1 / -1; /* ocupa todo el ancho del grid */
  border: none;
  border-top: 1px solid white;
  margin: 10px 0;
  opacity: 0.5;
  margin-right: 20%;
}
.footer-style {
  text-align: center;
  background: $naranja;
  // font-weight: 300 !important;
  color: #fff;
  // padding: 10px;
  // height: 50%;
  padding: 5% 0%;
}
.title_footer {
  font-size: 20px;
  // font-family: 'roboto-black';
  font-family: 'roboto-cursiva-bold';
}
.footer-style h3 {
  // font-weight: 300;
  // margin: 10px;
  font-family: 'roboto-cursiva-bold';

  margin-bottom: 0px;
  // font-size: 22px;
  text-align: initial;
  margin-top: 0px;
}
// .logo-footer {
//   width: 30%;
//   margin-top: -20px;
// }
.integridad-css,
.asesoramiento-css {
  text-align: left;
}
.redes-css {
  text-align: justify;
}
.padding-footer {
  padding: 0% 10% 12% 10%;
}
.padding-footer1 {
  padding: 12% 10% 12% 10%;
}
.padding-footer2 {
  padding: 0% 10% 0% 10%;
}
@media (min-width: 2561px) {
  .footer-style h3 {
    font-size: 25px;
  }
  .p-css {
    font-size: 17px;
  }
  .css-link {
    font-size: 24px;
  }
  .logo-footer {
    width: 160px;
    padding: 0px 0% 0px 5%;
  }
  .css-link_2 {
    color: white;
    font-size: 20px;
    font-family: 'roboto-regular';
  }
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .footer-style h3 {
    font-size: 25px;
  }
  .p-css {
    font-size: 17px;
  }
  .css-link {
    font-size: 20px;
  }
  .logo-footer {
    height: 75px;
    padding: 0px 0% 0px 5%;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .footer-style h3 {
    font-size: 27px;
  }
  .p-css {
    font-size: 18px;
  }
  .css-link {
    font-size: 19px;
  }
  .logo-footer {
    height: 75px;

    padding: 0px 0% 0px 10%;
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .icono-footer {
    width: 8%;
  }
  .logo-footer {
    // width: 40%;
    width: 130px;
    padding: 0px 0% 0px 20%;
  }
  .footer-style h3 {
    font-size: 22px;
  }
  .p-css {
    font-size: 15px;
  }
  .css-link {
    font-size: 17px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .icono-footer {
    width: 5%;
  }
  .logo-footer {
    width: 130px;
  }
  .footer-style h3 {
    font-size: 21px;
  }
  .p-css {
    font-size: 15px;
  }
  .css-link {
    font-size: 17px;
  }
  .linea-blanca {
    margin-right: 0px;
    // width: 50%;
  }
}
@media (orientation: portrait) {
  @media screen and (min-width: 375px) and (max-width: 767px) {
    .icono-footer {
      width: 9%;
      margin-bottom: 5px;
    }
    .logo-footer {
      width: 30%;
      padding-top: 10%;
    }
    .footer-style h3 {
      font-size: 20px;
      margin: 10px 0px;
    }
    .p-css {
      font-size: 15px;
    }
    .css-link {
      font-size: 18px;
    }
    .footer-style {
      padding: 5% 0%;
    }
    .linea-blanca {
      margin-right: 0px;
      // width: 50%;
    }
    .integridad-css {
      text-align: left;
    }
  }
  @media (max-width: 375px) {
    .icono-footer {
      width: 9%;
      margin-bottom: 5px;
    }
    .logo-footer {
      width: 30%;
      padding-top: 10%;
    }
    .footer-style h3 {
      font-size: 20px;
      margin: 10px 0px;
    }
    .p-css {
      font-size: 17px;
    }
    .css-link {
      font-size: 19px;
    }
    .footer-style {
      padding: 5% 0%;
    }
    .linea-blanca {
      margin-right: 0px;
    }
  }
}
@media (orientation: landscape) and (max-height: 450px) {
  .logo-footer {
    width: 20%;
    padding-top: 5%;
    padding-bottom: 5%;
  }
  .footer-style {
    padding: 0%;
  }
  .padding-footer {
    padding: 0% 10% 5% 10%;
  }
  .padding-footer2 {
    padding: 0% 10% 0% 10%;
  }
  .padding-footer1 {
    padding: 5% 10% 5% 10%;
  }
}
</style>
